import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    if_login: false,
    default_rule: {
      id: "",
      name: "",
      nextid: 9,
      keyTable: []
    },
    xmgl_default_active:'/xmgl/dep',
    default_active:'xxcj',
    user: {
      phone: "",
      id: "",
      name: "",
      city: null,
      area: null,
      school: null,
      level: "",
      gateway: null,
      subjectCodes: "",
      schoolCode: "",
      keyTable: "",
      rules: "",
      subjects: [],
      access: [],
      main_menu: [],
      accessname: "",
      helf_url:""
    }
  },
  mutations: {
    login(state) {
      state.if_login = true;
    },
    logout(state) {
      state.if_login = false;
      state.user = {
        phone: "",
        id: "",
        name: "",
        city: null,
        area: null,
        school: null,
        level: "",
        gateway: null,
        keyTable: "",
        rules: "",
        subjects: "",
        access: [],
        main_menu: [],
        accessname: "",
        helf_url:""
      }
    }
  },
  actions: {}
})